import gql from 'graphql-tag';

export const DEAL_EMAIL_ACTIVITY_FRAGMENT = gql`
  fragment DealEmailActivityFields on DealEmailActivityViewModel {
    id
    type
    emailTo
    parentId
    emailFrom
    emailText
    emailHTML
    emailSubject
    createdDateTime
    updatedDateTime
  }
`;
